import * as THREE from 'three'

import Experience from './Experience.js'

/*
 * 煮鱼的专属道具 —— 克制原则：只保留身份识别度最高的内容
 *   1. 成都蓉城围巾（TV 墙前段，对照真实球迷围巾绘制）
 *   2. 礼物盒（仅 7.14 生日或 ?hbd 出现，彩蛋入口）
 * （煮鱼台标在 BouncingLogo.js，影视飓风在 ZhuyuScreen.js）
 * 场景无实时灯光，材质全部 MeshBasicMaterial，明暗画进贴图
 */
const POS = {
    scarf: { x: -4.62, y: 3.7, z: 4.05, ry: Math.PI / 2 },
    gift: { x: -1.2, y: 0, z: 3.6 }
}

export default class ZhuyuProps
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time

        this.group = new THREE.Group()
        this.scene.add(this.group)

        this.interactives = []

        this.setScarf()

        const now = new Date()
        const isBirthday = now.getMonth() + 1 === 7 && now.getDate() === 14
        if(isBirthday || /[?&]hbd\b/.test(location.search))
            this.setGift()
    }

    box(w, h, d, color)
    {
        return new THREE.Mesh(
            new THREE.BoxGeometry(w, h, d),
            new THREE.MeshBasicMaterial({ color })
        )
    }

    canvasTexture(w, h, draw)
    {
        const cv = document.createElement('canvas')
        cv.width = w
        cv.height = h
        draw(cv.getContext('2d'), w, h)
        const t = new THREE.CanvasTexture(cv)
        t.encoding = THREE.sRGBEncoding
        return t
    }

    tagInteractive(object, name, action)
    {
        object.traverse((o) => { o.userData.zhuyu = { name, action } })
        this.interactives.push(object)
    }

    /* ---------- 成都蓉城围巾 ---------- */
    drawCrest(c, cx, cy, s)
    {
        c.save()
        c.translate(cx, cy)
        c.scale(s, s)
        c.beginPath()
        c.moveTo(0, -50)
        c.lineTo(42, -34)
        c.lineTo(42, 16)
        c.quadraticCurveTo(42, 44, 0, 58)
        c.quadraticCurveTo(-42, 44, -42, 16)
        c.lineTo(-42, -34)
        c.closePath()
        c.fillStyle = '#f3ede0'
        c.fill()
        c.lineWidth = 7
        c.strokeStyle = '#b2251c'
        c.stroke()
        c.save()
        c.clip()
        c.fillStyle = '#b2251c'
        c.beginPath()
        c.moveTo(-52, 14)
        c.lineTo(20, -58)
        c.lineTo(52, -30)
        c.lineTo(-24, 46)
        c.closePath()
        c.fill()
        c.restore()
        c.fillStyle = '#c99a2e'
        c.font = 'bold 30px sans-serif'
        c.textAlign = 'center'
        c.fillText('★', 0, -14)
        c.fillStyle = '#7c1610'
        c.font = 'bold 22px "PingFang SC", "Microsoft YaHei", sans-serif'
        c.fillText('蓉城', 0, 34)
        c.restore()
    }

    setScarf()
    {
        const tex = this.canvasTexture(512, 2048, (c, W, H) =>
        {
            c.clearRect(0, 0, W, H)
            const FR = 70
            const BLK = 240
            const BAND = 66

            const bodyTop = FR + BLK + BAND
            const bodyBot = H - FR - BLK - BAND

            /* 主体：双色红斜纹 + 针织横纹 */
            c.save()
            c.beginPath()
            c.rect(0, bodyTop, W, bodyBot - bodyTop)
            c.clip()
            c.fillStyle = '#b2251c'
            c.fillRect(0, bodyTop, W, bodyBot - bodyTop)
            c.strokeStyle = '#9a1d15'
            c.lineWidth = 26
            for(let d = -H; d < H * 2; d += 52)
            {
                c.beginPath()
                c.moveTo(-40, d)
                c.lineTo(W + 40, d - W)
                c.stroke()
            }
            for(let y = bodyTop; y < bodyBot; y += 6)
            {
                c.fillStyle = y % 12 ? 'rgba(0,0,0,.06)' : 'rgba(255,255,255,.03)'
                c.fillRect(0, y, W, 3)
            }
            c.restore()

            /* 成都雄起（竖排，白字深边） */
            c.textAlign = 'center'
            c.font = 'bold 150px "PingFang SC", "Microsoft YaHei", sans-serif'
            const chars = '成都雄起'
            const mid = (bodyTop + bodyBot) / 2
            const list = [...chars]
            for(let i = 0; i < list.length; i++)
            {
                const y = mid + (i - 1.5) * 190 + 55
                c.lineWidth = 16
                c.strokeStyle = '#6e120c'
                c.strokeText(list[i], W / 2, y)
                c.fillStyle = '#f7f2e6'
                c.fillText(list[i], W / 2, y)
            }

            /* 侧边 FOR BETTER CITY */
            c.save()
            c.translate(58, mid)
            c.rotate(-Math.PI / 2)
            c.fillStyle = 'rgba(247,242,230,.85)'
            c.font = 'bold 34px Arial, sans-serif'
            c.fillText('FOR BETTER CITY', 0, 0)
            c.restore()
            c.save()
            c.translate(W - 58, mid)
            c.rotate(Math.PI / 2)
            c.fillStyle = 'rgba(247,242,230,.85)'
            c.font = 'bold 34px Arial, sans-serif'
            c.fillText('FOR BETTER CITY', 0, 0)
            c.restore()

            /* 白带 RONGCHENG FC */
            const bandYs = [FR + BLK, H - FR - BLK - BAND]
            for(const y of bandYs)
            {
                c.fillStyle = '#f3ede0'
                c.fillRect(0, y, W, BAND)
                c.fillStyle = '#b2251c'
                c.font = 'bold 40px Arial, sans-serif'
                c.fillText('RONGCHENG FC', W / 2, y + BAND / 2 + 14)
            }

            /* 黑块 + 队徽 */
            const blkYs = [FR, H - FR - BLK]
            for(const y0 of blkYs)
            {
                c.fillStyle = '#17151a'
                c.fillRect(0, y0, W, BLK)
                for(let y = y0; y < y0 + BLK; y += 6)
                {
                    c.fillStyle = y % 12 ? 'rgba(255,255,255,.025)' : 'rgba(0,0,0,.12)'
                    c.fillRect(0, y, W, 3)
                }
                this.drawCrest(c, W / 2, y0 + BLK / 2, 1.15)
            }

            /* 流苏 */
            c.lineWidth = 11
            for(let x = 14; x < W; x += 26)
            {
                c.strokeStyle = x % 52 ? '#a8221a' : '#8f1c15'
                c.beginPath()
                c.moveTo(x, FR)
                c.lineTo(x + 5, 6)
                c.stroke()
                c.beginPath()
                c.moveTo(x, H - FR)
                c.lineTo(x - 5, H - 6)
                c.stroke()
            }

            /* 夜晚明暗：顶部环境紫 + 底部压暗 + 边缘 AO */
            const shade = c.createLinearGradient(0, 0, 0, H)
            shade.addColorStop(0, 'rgba(130,90,160,.22)')
            shade.addColorStop(0.5, 'rgba(0,0,0,.14)')
            shade.addColorStop(1, 'rgba(0,0,0,.42)')
            c.globalCompositeOperation = 'source-atop'
            c.fillStyle = shade
            c.fillRect(0, 0, W, H)
            const edge = c.createLinearGradient(0, 0, W, 0)
            edge.addColorStop(0, 'rgba(0,0,0,.32)')
            edge.addColorStop(0.18, 'rgba(0,0,0,0)')
            edge.addColorStop(0.82, 'rgba(0,0,0,0)')
            edge.addColorStop(1, 'rgba(0,0,0,.32)')
            c.fillStyle = edge
            c.fillRect(0, 0, W, H)
            c.globalCompositeOperation = 'source-over'
        })

        /* 多段平面 + 轻微波浪，避免纸片感 */
        const geo = new THREE.PlaneGeometry(0.42, 1.68, 8, 24)
        const pos = geo.attributes.position
        for(let i = 0; i < pos.count; i++)
        {
            const y = pos.getY(i)
            pos.setZ(i, Math.sin(y * 4.2) * 0.022 + Math.cos(pos.getX(i) * 9) * 0.012)
        }
        geo.computeVertexNormals()

        const scarf = new THREE.Mesh(
            geo,
            new THREE.MeshBasicMaterial({ map: tex, transparent: true, side: THREE.DoubleSide })
        )
        scarf.position.set(POS.scarf.x, POS.scarf.y, POS.scarf.z)
        scarf.rotation.y = POS.scarf.ry
        scarf.rotation.z = 0.02

        const pin = this.box(0.03, 0.03, 0.03, 0x101014)
        pin.position.set(POS.scarf.x - 0.02, POS.scarf.y + 0.83, POS.scarf.z)

        this.group.add(scarf, pin)
        this.tagInteractive(scarf, '成都蓉城 · 雄起！', { type: 'none' })
    }

    /* ---------- 礼物盒：分面明暗 + 包装纹理 + 蝴蝶结 + 接触阴影 ---------- */
    giftFaceMaterial(baseHex, brightness)
    {
        const cv = document.createElement('canvas')
        cv.width = 128
        cv.height = 128
        const c = cv.getContext('2d')
        const base = new THREE.Color(baseHex).multiplyScalar(brightness)
        c.fillStyle = '#' + base.getHexString()
        c.fillRect(0, 0, 128, 128)
        c.fillStyle = 'rgba(255,255,255,.07)'
        for(let y = 8; y < 128; y += 16)
        {
            for(let x = (y % 32) ? 8 : 16; x < 128; x += 16)
                c.fillRect(x, y, 3, 3)
        }
        const g = c.createLinearGradient(0, 0, 0, 128)
        g.addColorStop(0, 'rgba(255,220,180,.10)')
        g.addColorStop(1, 'rgba(0,0,0,.22)')
        c.fillStyle = g
        c.fillRect(0, 0, 128, 128)
        const t = new THREE.CanvasTexture(cv)
        t.encoding = THREE.sRGBEncoding
        return new THREE.MeshBasicMaterial({ map: t })
    }

    setGift()
    {
        const g = new THREE.Group()
        const RED = 0xa8241a
        const GOLD = 0xc99a2e
        const goldDim = new THREE.Color(GOLD).multiplyScalar(0.7)

        const mats = [
            this.giftFaceMaterial(RED, 1.05),
            this.giftFaceMaterial(RED, 0.55),
            this.giftFaceMaterial(RED, 1.25),
            this.giftFaceMaterial(RED, 0.4),
            this.giftFaceMaterial(RED, 0.95),
            this.giftFaceMaterial(RED, 0.5)
        ]
        const body = new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.28, 0.4), mats)
        body.position.y = 0.14

        const lidMats = [
            this.giftFaceMaterial(RED, 1.15),
            this.giftFaceMaterial(RED, 0.6),
            this.giftFaceMaterial(RED, 1.35),
            this.giftFaceMaterial(RED, 0.45),
            this.giftFaceMaterial(RED, 1.0),
            this.giftFaceMaterial(RED, 0.55)
        ]
        const lid = new THREE.Mesh(new THREE.BoxGeometry(0.44, 0.09, 0.44), lidMats)
        lid.position.y = 0.325

        const ribbonMatBright = new THREE.MeshBasicMaterial({ color: GOLD })
        const ribbonMatDim = new THREE.MeshBasicMaterial({ color: goldDim })
        const ribA = new THREE.Mesh(new THREE.BoxGeometry(0.452, 0.40, 0.075), ribbonMatBright)
        ribA.position.y = 0.185
        const ribB = new THREE.Mesh(new THREE.BoxGeometry(0.075, 0.40, 0.452), ribbonMatDim)
        ribB.position.y = 0.185

        const bowMat = new THREE.MeshBasicMaterial({ color: GOLD })
        const loopL = new THREE.Mesh(new THREE.TorusGeometry(0.055, 0.02, 8, 20), bowMat)
        loopL.scale.set(1, 0.65, 0.55)
        loopL.rotation.z = 0.5
        loopL.position.set(-0.055, 0.415, 0)
        const loopR = loopL.clone()
        loopR.rotation.z = -0.5
        loopR.position.x = 0.055
        const knot = new THREE.Mesh(new THREE.SphereGeometry(0.032, 10, 8), ribbonMatDim)
        knot.position.y = 0.395

        const shCv = document.createElement('canvas')
        shCv.width = 128
        shCv.height = 128
        const sc = shCv.getContext('2d')
        const sg = sc.createRadialGradient(64, 64, 8, 64, 64, 62)
        sg.addColorStop(0, 'rgba(0,0,0,.5)')
        sg.addColorStop(0.7, 'rgba(0,0,0,.22)')
        sg.addColorStop(1, 'rgba(0,0,0,0)')
        sc.fillStyle = sg
        sc.fillRect(0, 0, 128, 128)
        const shTex = new THREE.CanvasTexture(shCv)
        const shadow = new THREE.Mesh(
            new THREE.PlaneGeometry(0.72, 0.72),
            new THREE.MeshBasicMaterial({ map: shTex, transparent: true, depthWrite: false })
        )
        shadow.rotation.x = -Math.PI / 2
        shadow.position.y = 0.006

        g.add(shadow, body, lid, ribA, ribB, loopL, loopR, knot)
        g.position.set(POS.gift.x, POS.gift.y, POS.gift.z)
        g.rotation.y = 0.4
        this.group.add(g)
        this.tagInteractive(g, '？？？', { type: 'egg' })
        this.gift = g
    }

    update()
    {
        if(this.gift)
            this.gift.rotation.y = 0.4 + Math.sin(this.time.elapsed * 0.001) * 0.08
    }
}
